// extracted by mini-css-extract-plugin
module.exports = {"Icon":"Icon_Icon__eVzju","baseline":"Icon_baseline__2Ui3j","bottom":"Icon_bottom__kbero","middle":"Icon_middle__2ULVw","top":"Icon_top__2B5is"};